var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slot__wrapper"},[(_vm.prefix)?_c('Affix',_vm._b({},'Affix',_vm.prefix,false)):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.suffix)?_c('Affix',_vm._b({},'Affix',_vm.suffix,false)):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }